<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini" :inline="false">
            <el-form-item class="form-title" prop="i_id" label="银行ID" style="width: 350px">
                <div class="mrA">{{formData.i_id}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_name" label="银行名称" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_name" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_name}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_type" label="银行类型" style="width: 350px" required>
                <el-radio-group v-model="formData.i_type" @input="typeChange" v-if="canEdit">
                    <el-radio  :label="0">总行</el-radio>
                    <el-radio  :label="1">分支行/营业部</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_type==1?'分支行/营业部':'总行'}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_pid" label="所属总行" style="width: 350px" v-if="formData.i_type==1">
                <el-select @change="sszhChange" v-model="formData.i_pid" size="mini"  filterable clearable :remote="true"
                           :remote-method="banksearch" style="width:100%; "v-if="canEdit">
                    <el-option v-for="item in bankList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_pname}}</div>
            </el-form-item>

            <el-form-item prop="i_state" label="是否作废" style="width: 350px" v-if="data.i_id!=0">
                <el-radio-group v-model="formData.i_state" v-if="canEdit">
                    <el-radio  :label="-1">是</el-radio>
                    <el-radio  :label="0">否</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_state==-1?'是':'否'}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_order" label="排序号" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.i_order" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.i_order}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_lruname" label="录入人" style="width: 350px" >
                <div class="mrA" >{{formData.vc_lruname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="dt_createtime" label="录入时间" style="width: 350px" >
                <div class="mrA" >{{formData.dt_createtime}}</div>
            </el-form-item>
        </el-form>
        <div  class="center">
                <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">作废</el-button>-->
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
                <!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "GsPage",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_name:'',
                    i_type:0,
                    i_state:0,
                    i_pid:'',
                },
                canEdit:false,
                disabled:false,
                bankList:[],
                rules:{
                    vc_name:[{required: true,message:'银行名称不能为空'}],

                    i_type:[{required: true,message:'银行类型不能为空'}],
                    i_pid:[{required: true,message:'所属总行不能为空'}],
                    // i_state:[{required: true,message:'是否启用不能为空'}],
                }
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
            //data:{
            //     handler(){
            //         if(this.data.i_id==0){
            //             this.canEdit=true
            //             this.getbzlist();
            //             this.getDqList();
            //             this.now=this.$DateTime.now();
            //             this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
            //             this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
            //             this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            //         }else{
            //             this.formData=JSON.parse(JSON.stringify(this.data))
            //         }
            //         console.log(this.data,'handler',this.formData)
            //
            //     },
            //     immediate:true,
            //     deep:true
            // },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.now=this.$DateTime.now();
            this.$nextTick(() => {
                this.onResize();
            });
            if(this.data.i_id==0){
                this.canEdit=true;
                this.getParentBankList();
                this.formData.i_id=0
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            }else{
                this.formData=JSON.parse(JSON.stringify(this.data))
            }
            // this.formData=JSON.parse(JSON.stringify(this.data));
            console.log(this.data,'mounted',this.formData)


        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            typeChange(){
                // if (this.formData.i_type==0){
                    this.formData.i_pid=''
                // }
            },
            sszhChange(val){
                this.$set(this.formData,'i_pid',val)
                this.formData.vc_pname=this.bankList.find(i=>i.i_id==this.formData.i_pid).vc_name
                // console.log(this.formData,val)
                // this.$forceUpdate()
            },
            cancel(){
                this.$emit('close')
            },
            save(formName){
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        if(this.data.i_id==0){
                            this.addBankDict()

                        }else{
                            this.editBankDict()
                        }
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.canEdit=true
                this.getParentBankList()

            },
            //延迟搜索
            banksearch(val){
                this.bank_search=val;
                this.getParentBankList()
            },
            //总行
            async getParentBankList(){
                let param={
                    vc_search:this.bank_search,
                };
                let res=await API.getParentBankList(param);
                if ( res.code == 1 ){
                    this.bankList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //新增
            async addBankDict(){
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.addBankDict(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.canEdit=false
                }
            },
            //编辑
            async editBankDict(){
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.editBankDict(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.canEdit=false
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }

</style>